// UsersManagement.tsx

import { /*useRef,*/ useState } from 'react';
import styles from './UsersManagement.module.css';
// import useOnClickOutside from '../hooks/useOnClickOutside.ts';
import Modal from '../components/Modal.tsx';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { CiEdit } from 'react-icons/ci';
import Spinner from '../components/Spinner.tsx';
import { useUsers } from '../hooks/useUsers.ts';
import Pagination from '../components/Pagination.tsx';

interface Organization {
  id: number;
  name: string;
}

interface User {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  roles: string[];
  organizations: Organization[];
}

const getData = function (users: User[] | undefined, page: number, limit: number) {
  if (users === undefined) {
    return [];
  }
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  return users.slice(startIndex, endIndex);
};

function getRole(role: string): string {
  if (!role) {
    return 'Not defined';
  }
  const rolesObject: { [key: string]: string } = {
    Admin: 'Admin',
    User: 'User',
    Viewer: 'Viewer',
    Editor: 'Editor',
    'Sensor provider': 'Sensor Provider',
    Manager: 'Manager',
  };

  return rolesObject[role] || role;
}

function UsersManagement() {
  const { isLoading, allUsers, error } = useUsers();
  const [currentPage, setCurrentPage] = useState(1);
  const limitOfUsers = 10;
  // const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  // const popUpMenuRef = useRef<HTMLDivElement>(null);

  // const clickOutSideHandler = () => {
  //   setShowModal(false);
  // };

  // useOnClickOutside(popUpMenuRef, clickOutSideHandler);

  const handleEdit = (id: string) => {
    setSelectedItem(id);
    setOpen(true);
  };

  const handleDelete = (id: string) => {
    setSelectedItem(id);
    setOpenConfirm(true);
  };

  // const handleActionsClick = (id: string) => {
  //   setShowModal(!showModal);
  //   setSelectedItem(id);
  // };

  const renderUsers = () => {
    return getData(allUsers, currentPage, limitOfUsers)
      .filter((user) => user !== undefined)
      .map((user) => {
        return (
          <tr key={user.email}>
            <td>
              <div className={styles.avatar}>
                {`${user.first_name} ${user.last_name}`}
              </div>
            </td>
            <td>{user.email}</td>
            {/* <td>
              {user.organizations && user.organizations.length > 0
                ? user.organizations.map((org) => org.name).join(', ')
                : '-'}
            </td> */}
            <td className={styles.role_info}>
              <div
                className={`${styles.role} ${
                  user.roles && user.roles.length > 0
                    ? styles[`role_${user.roles[0].toLowerCase()}`]
                    : ''
                }`}
              >
                {user.roles && user.roles.length > 0 ? getRole(user.roles[0]) : 'No Role'}
              </div>
              <div className={styles.actions}>
                <button
                  className={styles.actionButton}
                  onClick={() => handleEdit(user.id)}
                  title="Edit User"
                >
                  <CiEdit size={18} />
                </button>
                <button
                  className={styles.actionButtonDelete}
                  onClick={() => handleDelete(user.id)}
                  title="Delete User"
                >
                  <MdOutlineDeleteOutline size={18} />
                </button>
              </div>
            </td>
          </tr>
        );
      });
  };

  return (
    <>
      {isLoading && <Spinner />}
      {allUsers && !isLoading && !error && (
        <>
          <div className={styles.usersTable}>
            <div className={styles.tableContainer}>
              <table>
                <thead>
                  <tr>
                    <th>
                      <span style={{ marginRight: 10 }}>Name</span>
                    </th>
                    <th>
                      <span>Email</span>
                    </th>
                    {/* <th>
                      <span>Organization</span>
                    </th> */}
                    <th>
                      <span>Role</span>
                    </th>
                  </tr>
                </thead>
                <tbody>{renderUsers()}</tbody>
              </table>
            </div>
          </div>
          {allUsers.length > limitOfUsers && (
            <Pagination
              currentPage={currentPage}
              lastPage={Math.ceil(allUsers.length / limitOfUsers)}
              maxLength={7}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
      {open && (
        <Modal
          open={open}
          setOpen={setOpen}
          edit={true}
          userId={selectedItem}
          allUsers={allUsers}
        />
      )}

      {openConfirm && (
        <Modal
          open={openConfirm}
          setOpen={setOpenConfirm}
          confirm={true}
          userId={selectedItem}
          allUsers={allUsers}
        />
      )}
      {error && <p>An error occurred: {error.message}</p>}
    </>
  );
}

export default UsersManagement;
